import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFlagE = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "none",
	height: 16,
	viewBox: "0 0 16 16",
	width: 16,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_2056_28812)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8Z",
			fill: "#19C4E6"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M5.20077 12.195V3.81695H10.9022V5.43736H7.02523V7.15379H10.3501V8.76219H7.02523V10.5746H10.9022V12.195H5.20077Z",
			fill: "white"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_2056_28812",
		children: /* @__PURE__ */ _jsx("rect", {
			fill: "white",
			height: 16,
			width: 16
		})
	}) })]
});
export default SvgFlagE;
